module.exports = __webpack_public_path__ + "static/media/community_guideline_th_TH.0d09e9be.md";


//////////////////
// WEBPACK FOOTER
// ./src/policies/community_guideline_th_TH.md
// module id = 46
// module chunks = 0